export const getParsedApiChartResponse = (input: Record<string, any>) => {
  const output: Record<string, any> = {};

  Object.keys(input).forEach((chartKey) => {
    const val = input[chartKey];

    if (Array.isArray(val)) { // flatten array of objects into one object
      output[chartKey] = Object.assign({}, ...val);
    } else { // if it's an object with arrays inside, flatten those arrays too
      output[chartKey] = {};
      Object.keys(val).forEach((subKey) => {
        const subVal = val[subKey];
        output[chartKey][subKey] = Array.isArray(subVal)
          ? Object.assign({}, ...subVal)
          : subVal;
      });
    }
  });

  return output;
};
